import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faXmark } from "@fortawesome/free-solid-svg-icons";

export const SearchComponent = ({
  value,
  regexName,
  onChange,
  placeholder,
  clearTextLabel,
  hidden = false,
}) => {
  return (
    <div className={`flex w-full h-full ${hidden ? "pr-4" : ""}`}>
      <div className="flex w-full h-full">
        <div className="flex w-full border-2 border-primary-ShadowPCP004 rounded-l-lg">
          <input
            className="h-full w-full flex-1 rounded-l-lg border-0 bg-transparent px-2"
            type="text"
            maxLength={80}
            pattern={regexName}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
          />

          <button
            type="button"
            className={`h-full w-10 flex items-center justify-center ${
              !value?.length ? "hidden" : ""
            }`}
            onClick={clearTextLabel}
          >
            <FontAwesomeIcon
              size="sm"
              className="text-black hover:text-gray-400"
              icon={faXmark}
            />
          </button>
        </div>

        <div className="flex w-8 items-center justify-center rounded-r-lg bg-primary-ShadowPCP004">
          <FontAwesomeIcon className="text-white" icon={faSearch} />
        </div>
      </div>
    </div>
  );
};

